export enum Day {
    Monday = 'monday',
    Tuesday = 'tuesday',
    Wednesday = 'wednesday',
    Thursday = 'thursday',
    Friday = 'friday',
    Saturday = 'saturday',
    Sunday = 'sunday',
}

// const translationObject: { [Key in ImportSupplierStatus]: string } = {
//     [ImportSupplierStatus.NoInterval]: 'app.bonusSettlement.status.draft',
//     [ImportSupplierStatus.OnSchedule]: 'app.bonusSettlement.status.sent',
//     [ImportSupplierStatus.Overdue]: 'app.bonusSettlement.status.readyToComplete',
// };

// export const getImportSupplierStatusTranslationId = (status?: ImportSupplierStatus): string => {
//     return status ? translationObject[status] : 'app.bonusSettlement.status.draft';
// };
